module.exports = __webpack_public_path__ + "img/1.fa621ebb.jpg";